export default "__VITE_ASSET__CIzRp00F__"